import React, { useRef }  from 'react';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';

function PlayerDropboxNew(props){
    const { t, i18n } = useTranslation();



    return(
     
                    <div style={{zIndex: 1}} id="video1container" className=" row justify-content-center video-wrapper" >      
                        
                        <ReactPlayer controls="true" width="840" height="472" id="video1" className=" img-fluid rounded "   frameBorder="0"  allowFullScreen url={props.source}    playing={true}/>
                    
                      
                    </div> 
    
)}

export default PlayerDropboxNew;